import { render, staticRenderFns } from "./ComponentProxy.vue?vue&type=template&id=abfe5cea&"
import script from "./ComponentProxy.vue?vue&type=script&lang=js&"
export * from "./ComponentProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports